import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Docs.css';
import triangle from '../assets/triangle_bleu.png';
import pdf from '../assets/pdf.png';
import { domain } from '../variables';

const CATEGORIES = [
    {id: 1, title: "Cahier des charges", folder: ""},
    {id: 2, title: "Calendriers officiels", folder: "calendrier/"},
    {id: 3, title: "Listes Pro", folder: "listes/"},
    {id: 4, title: "Listes des référents", folder: "referents/"},
    {id: 5, title: "Tenues Sportives", folder: "tenues/"},
    {id: 6, title: "Livescoring", folder: ""},
]

function Docs() {
    const [documents, setDocuments] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0)
        getDocuments()
    }, [])

    const getDocuments = async () => {
        try {
            const res = await axios.post(domain + '/server/getDocuments.php', {});
            setDocuments(Array.isArray(res.data) ? res.data : []);
        } catch (e) {
            setDocuments([]);
        } finally {
            setLoaded(true);
        }
    }

    const parseDate = (dateAjout) => {
        if (!dateAjout) return null;
        const date = new Date(dateAjout.replace(' ', 'T'));
        return isNaN(date.getTime()) ? null : date;
    }

    const isNouveau = (dateAjout) => {
        const date = parseDate(dateAjout);
        if (!date) return false;
        const diffDays = (Date.now() - date.getTime()) / (1000 * 60 * 60 * 24);
        return diffDays >= 0 && diffDays <= 5;
    }

    const formatDate = (dateAjout) => {
        const date = parseDate(dateAjout);
        return date ? date.toLocaleDateString('fr-FR') : null;
    }

    const goToPDF = (e, link) => {
        e.preventDefault();
        window.open(link, '_blank');
    }

    const sections = CATEGORIES.map((cat) => ({
        ...cat,
        data: documents.filter((doc) => parseInt(doc.categorie, 10) === cat.id)
    }))

    return (
        <div className="docs_page">
            {/* // BANNIERE */}
            <div className={"top_banniere actus"}>
                <span className="top_banniere_title">
                    Documentation
                </span>
            </div>
            <div className="docs_content">
                {
                    loaded && sections.map((item) => {
                        return (
                            item.data.length > 0 ?
                            <div key={item.id} className="docs_items" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                <h1>
                                    {item.title}
                                </h1>
                                <div className="docs_documents">
                                    {
                                        item.data.map((doc) => {
                                            const link = process.env.PUBLIC_URL + '/docs/' + item.folder + doc.fichier;
                                            return (
                                                <div key={doc.idDocument}>
                                                    <div style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                                                        <a href={link} target='_blank' rel="noreferrer">
                                                            <img src={triangle} alt="" style={{marginRight: 20}} />
                                                            {
                                                                doc.titre
                                                            }
                                                            {
                                                                formatDate(doc.dateAjout) &&
                                                                <span className="docs_date">Ajouté le {formatDate(doc.dateAjout)}</span>
                                                            }
                                                            {
                                                                isNouveau(doc.dateAjout) &&
                                                                <span className="badge_nouveau">Nouveau</span>
                                                            }
                                                        </a>
                                                        <img src={pdf} alt="PDF" style={{cursor: 'pointer'}} width="64" height="64" onClick={(e)=>goToPDF(e, link)} />
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            :
                            <div key={item.id} className="docs_items" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                <h1>
                                    {item.title}
                                </h1>
                                <div className="docs_documents" style={{textAlign: 'center'}}>
                                    Aucun document disponible
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
}

export default Docs;
